// frontend/src/hooks/useValidationConfig.js
import { useEffect } from 'react'
import { ID_VALIDATION_CONFIG } from '../config/idValidation'

/**
 * Devuelve la configuración de validación según la nacionalidad seleccionada.
 * @param {string}   countryCode  Código ISO-2 del país seleccionado (ej. 'DO', 'VE').
 * @param {Function} setConfig    Setter de estado en el componente.
 */
export function useValidationConfig(countryCode, setConfig) {
  useEffect(() => {
    if (!countryCode) {
      setConfig(null)
      return
    }

    // Busca el país en el objeto de validadores
    const cfg = ID_VALIDATION_CONFIG.validators[countryCode] || null
    setConfig(cfg)
  }, [countryCode, setConfig])
}
